import type LogDataType from '../schema/LogDataType';
import type LogOptions from '../schema/LogOptions';
import type Logger from '../schema/Logger';
import type ActionDp from '../schema/ActionDp';

let appLogger: Logger;

/** Util to initialize the Logger */
export function setLogger(logger: Logger) {
    appLogger = logger;
}

/** Util to get the logData function object */
export function getDataLogger(): LogDataType {
    return appLogger?.logData;
}

/** Util to get the Performance Datapoint logging object */
export function getActionDp(eventName: string, options?: LogOptions): ActionDp {
    return appLogger?.getActionDp?.(eventName, options);
}
